import { render, staticRenderFns } from "./BaseDialogCard.vue?vue&type=template&id=63fff323&scoped=true&"
import script from "./BaseDialogCard.vue?vue&type=script&lang=js&"
export * from "./BaseDialogCard.vue?vue&type=script&lang=js&"
import style0 from "./BaseDialogCard.vue?vue&type=style&index=0&id=63fff323&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63fff323",
  null
  
)

export default component.exports